import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../SetInventory/SetInventory";
import { ActionChange } from "../../ActionInfo/ActionInfo";

export const meetsCostRequirementsSingleSets = (
  cost: ActionChange,
  costIncrement: number,
  costScale: number,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
) => {
  // Validate if single cost can be met (brick or set)
  const trueCost = cost.baseChangeValue + costIncrement * costScale;

  // Default to "brick" if type not specified (backward compatibility)
  const costType = cost.type || "brick";

  if (costType === "brick") {
    // Check brick cost
    const currBrick = newBricks.get(cost.brickId);

    // If brick doesn't exist or amount is NaN, cost requirements are not met
    if (!currBrick || Number.isNaN(currBrick.amount)) {
      return false;
    }

    return currBrick.amount >= trueCost;
  } else if (costType === "set") {
    // Check set cost
    const currSet = newSets.get(cost.brickId); // brickId field contains set ID

    if (!currSet) {
      return false;
    }

    return currSet.count >= trueCost;
  }

  return false;
};
